import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CouponsSerivce {
  apiBaseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient) {}

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string}) {
    return this._httpClient.get(`${this.apiBaseUrl}/coupons`, { params });
  }

  deleteCoupons(id: string) {
    return this._httpClient.delete(`${this.apiBaseUrl}/coupons/${id}`);
  }

  getCoupons(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/coupons${query}`);
  }

  getCouponById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/coupons/${id}`);
  }

  updateCoupons(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/coupons/${id}`, data);
  }

  AddCoupons(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/coupons`, data);
  }


  updateFee(data: any) {
    return this._httpClient.patch(`${this.apiBaseUrl}/configs/adminFees`, data);
  }

  getFee() {
    return this._httpClient.get(`${this.apiBaseUrl}/configs/adminFees`);
  }

}
